import qs from 'qs';

function CommonHttpRequest(baseUrl) {
  const get = async (urlPath = '', params = {}) => {
    const queryString = qs.stringify(params);
    const url = `${baseUrl}${urlPath}?${queryString}`;
    console.log('url : ', url)
  
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
  
      const jsonResponse = await response.json();
      if (!jsonResponse) {
        return null;
      } else {
        return jsonResponse;
      }
    } catch (e) {
      console.error(e);
    }
  
    return null;
  };
  
  const post = async (urlPath = '', params = {}, headers = {}, body = {}) => {
    const queryString = qs.stringify(params);
    const url = `${baseUrl}${urlPath}?${queryString}`;
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          ...headers,
        },
        body,
      });
  
      const jsonResponse = await response.json();
  
      if (!jsonResponse) {
        return null;
      } else {
        return jsonResponse;
      }
    } catch (e) {
      console.error(e);
    }
  
    return null;
  };
  
  const request = async (urlPath = '', params = {}, body = {}, method = 'POST', credentials = null) => {
    const queryString = qs.stringify(params);
    const url = `${baseUrl}${urlPath}?${queryString}`;
  
    try {
      const options = {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
      }
  
      if (credentials) {
        options.credentials = credentials;
      }
  
      const response = await fetch(url, options);
  
      const jsonResponse = await response.json();
  
      if (!jsonResponse) {
        return null;
      } else {
        return jsonResponse;
      }
    } catch (e) {
      console.error(e);
    }
  
    return null;
  };
  
  const requestMultipart = async (urlPath = '', params = {}, formData = null, method = 'POST') => {
    const queryString = qs.stringify(params);
    const url = `${baseUrl}${urlPath}?${queryString}`;
  
    try {
      const response = await fetch(url, {
        method,
        headers: {
          Accept: 'application/json'
        },
        body: formData,
      });
  
      const jsonResponse = await response.json();
  
      if (!jsonResponse) {
        return null;
      } else {
        return jsonResponse;
      }
    } catch (e) {
      console.error(e);
    }
  
    return null;
  };
  
  const download = async (urlPath = '', params = {}, headers = {}, method = 'GET') => {
    const queryString = qs.stringify(params);
    const url = `${baseUrl}${urlPath}?${queryString}`;
  
    try {
      const response = await fetch(url, {
        method,
        headers: {
          ...headers
        },
      });
  
      if (!response) {
        return null;
      } else {
        return response;
      }
    } catch (e) {
      console.error(e);
    }
  
    return null;
  };

  return {
    get,
    post,
    request,
    requestMultipart,
    download
  }
}

export default CommonHttpRequest;